import { useRef } from "react";
import { ContainerText } from "./style";
import { useOptaWidget } from "./hooks/useOptaWidget.js";
import Widget from "./Widget";

const OptaWidget = ({ content: { value }, notaId, elementBodyId }) => {


    if(value?.widget?.widget == "comentary"){
        const { competition, match, widget, teamHome, playerTeamHome } = value;
        let widgetName = widget?.widget;
        let competitionId = competition?._id;
        let optaSeason = competition?.seasonId;
        let matchId = match?._id;
        let team = teamHome?._id;
        let player = playerTeamHome?._id;

        return (
                <>
                    <Widget widget={widgetName} uniqueCompetitions={competition?.uniqueCompetitions} competition={competitionId} season={optaSeason} match={matchId} team={team} player={player}/>
                </>
        )
    }else{
        const { widget: { widget: typeWidget } } = value;

        const nodoOpta = useRef(null);
        useOptaWidget(nodoOpta, value, typeWidget, notaId);

        return (
            <ContainerText ref={nodoOpta} className={typeWidget} id={elementBodyId} />
        );
    }
};

export default OptaWidget;
